/** The delivery channels the server routes (mirrors `@vello/notifications` `NotificationChannel`). */
export const NOTIFICATION_TEMPLATE_CHANNELS = ['PUSH', 'SMS', 'EMAIL', 'WHATSAPP', 'IN_APP'];
export class NotificationAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Publish a template version immutably (a changed body under an existing version → `CONFLICT`). */
    publishTemplate(input) {
        return this.client.request({ method: 'POST', path: '/v1/notifications/templates', body: input, auth: true });
    }
    /** The published catalog, optionally narrowed to one `key`; newest version first within (key, channel, locale). */
    listTemplates(key, limit) {
        const params = new URLSearchParams();
        if (key !== undefined && key !== '')
            params.set('key', key);
        if (limit !== undefined)
            params.set('limit', String(limit));
        const qs = params.toString();
        return this.client.request({ method: 'GET', path: `/v1/notifications/templates${qs !== '' ? `?${qs}` : ''}`, auth: true });
    }
}
//# sourceMappingURL=notifications-admin.js.map